export enum CashDiscountType {
  PER_ROOM = 'PerRoom',
  PER_PERSON = 'PerPerson',
}
